module.exports = __webpack_public_path__ + "img/stat_02_icon.94cfa956.png";